<template>
	<div class="container-fluid">
		<div class="row d-flex justify-content-center align-items-center text-center" v-if="rend_sel_customer">
			<div class="col-12">
				<div class="alert alert-primary m-2">
		    		<div class="h4 text-center">
		                <linkto :link="'/orders/new_order/products'"/>
		                Rendelés összesítés
		            </div>
		    	</div>
			</div>
			<div class="col-12 col-md-6 col-lg-3 mt-1">
				<div class="row d-flex justify-content-center align-items-center">
					<div class="col-6 h6 text-right">
						Rendelésszám:
					</div>
					<div class="col-6 h5 text-left">
						{{rendszam}}
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-3 mt-1">
				<div class="row d-flex justify-content-center align-items-center">
					<div class="col-6 h6 text-right">
						Vevő:
					</div>
					<div class="col-6 h5 text-left">
						{{rend_sel_customer.nev}}
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-3 mt-1">
				<div class="row d-flex justify-content-center align-items-center">
					<div class="col-6 h6 text-right">
						Kiszállítási dátum: 
					</div>
					<div class="col-6 h5">
						<span class="text-center">
							{{datum | day}}
						</span>
						<date-picker
							v-model="datum"
							:config="date_options"
							@dp-change="refreshdate"
							class="form-control text-center"
						>
						</date-picker>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-3 mt-1">
				<div class="row d-flex justify-content-center align-items-center">
					<div class="col-6 h6 text-right">
						Régió
					</div>
					<div class="col-6">
						<input type="number" v-model="regio" class="form-control">
					</div>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-3 mt-2">
					<div class="m-1 h5 text-left">
						<span class="h6">Számla típus:</span>
						<select v-model="szla_tipus" class="form-control">
							<option
								v-for="(item,index) in szla_tipusok"
								:key="`sz-${index}`"
								:value="item.id"
								:disabled="item.id === 0"
							>
								{{item.nev}}
							</option>
						</select>
					</div>
				
			</div>
			<div class="col-12 col-md-6 col-lg-3 mt-2">
				<div class="m-1 h5 text-left">
					<span class="h6">Számla kiállító:</span>
					<select v-model="szla_szolg" class="form-control">
						<option
							v-for="(item,index) in szolg"
							v-show="item.aktiv ==1"
							:key="`szolg-${index}`"
							:value="item.id"
							
						>
							{{item.nev}}
						</option>
					</select>
				</div>
			</div>
			<div class="col-12 col-md-6 col-lg-3">
	        	<div class="m-1 h5 text-left">
	        		<span class="h6">Kiegyenlítés helye</span>
	        		<select v-model="selectedPenztar" class="form-control">
						<option value="-1">Nincs</option>
						<option
							v-for="(v,k) in penztar"
							:key="k"
							:value="v.id"
						>
							{{ v.nev }}
						</option>
					</select>
				</div>
        	</div>
        	<div class="col-12 col-md-6 col-lg-3">
	        	<div class="m-1 h5 text-left">
	        		<span class="h6">Kiszállító</span>
	        		<select v-model="selectedKiszallito" class="form-control">
						<option value="-1">Nincs</option>
						<option
							v-for="(v,k) in kiszallitok2"
							:key="k"
							:value="v.azon"
						>
							{{ v.nev }}
						</option>
					</select>
				</div>
        	</div>
			<div class="col-12 col-md-6 col-lg-3 mt-2">
				<div class="row d-flex justify-content-center align-items-center text-center">
					<div class="col-6">
						<div class="form-check h5">
						  	<input class="form-check-input" type="checkbox" value="" id="lezar" v-model="lezarva">
						  	<label class="form-check-label" for="lezar">
						    	Rendelés lezárva
						  	</label>
						</div>
					</div>
					<div class="col-6">
						<div class="form-check h5">
						  	<input class="form-check-input" type="checkbox" value="" id="szamla" v-model="szamlazva">
						  	<label class="form-check-label" for="szamla">
						    	Rendelés számlázva
						  	</label>
						</div>
					</div>
				</div>
			</div>
			<div class="col-10">
				<hr>
			</div>
			<div class="col-12">
				<div class="row align-items-center">
					<div
						class="col-12 h5"
						v-for="(item,index) in inCart"
					>
						<div class="row d-flex justify-content-center align-items-center">
							<div class="col-12 col-lg-3">
								{{item.nev}}
							</div>
							<div class="col-6 col-lg-5">
								<div class="mui-textfield mui-textfield m-1">
							    	<input type="text" v-model="item.rendmegj">
							    	<label>Rendelés megj.</label>
							  	</div>
							</div>
							<div class="col-3 col-lg-1">
								{{item.db}} db
							</div>
							<div class="col-3 col-lg-1">
								{{item.db * item.ar}} Ft 
							</div>
							<div class="col-12 d-none d-md-block">
								<hr>
							</div>
						</div>
					</div>
					<div class="col-10 d-md-none">
						<hr>
					</div>
					<div class="col-12">
						<div class="h4 m-2">
							Végösszeg: {{cartSum}} Ft
						</div>
					</div>
					<div class="col-12" v-show="!success && szolg.length > 0">
						<button
							class="btn btn-lg btn-success m-2"
							@click.prevent="order"
							v-show="!isActDay"
						>
							Rögzítés
						</button>
						<button
							class="btn btn-lg btn-success m-2"
							@click.prevent="preorder"
							v-show="isActDay"
						>
							Rögzítés
						</button>
					</div>
					<div class="col-12" v-show="success">
						<button
							class="btn btn-lg btn-primary m-2"
							@click.prevent="reset"
						>
							Vissza a főoldalra
						</button>
					</div>
				</div>
			</div>
			<div class="col-12 mt-3 mb-3" v-show="success">
				<div class="text-center h4">
					Rögzített rendelés
				</div>
				<div v-for="(v,k) in inserted">
					<div class="row d-flex justify-content-center align-items-center">
						<div class="col-12 col-lg-3">
							{{v.nev}}
						</div>
						<div class="col-6 col-lg-5">
							<div class="mui-textfield mui-textfield m-1">
						    	<input type="text" v-model="v.rendmegj">
						    	<label>Rendelés megj.</label>
						  	</div>
						</div>
						<div class="col-3 col-lg-1">
							{{v.db}} db
						</div>
						<div class="col-3 col-lg-1">
							{{v.db * v.ar}} Ft 
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {mapGetters,mapActions} from 'vuex'
export default {
	name: 'order_sum',

	data() {
		return {
			datum: null,
			aktiv: 1,
			lezarva: false,
			szamlazva: false,
			szla_tipus: 1,
			szla_szolg: 1,
			szolg: [],
			regio: 0,
			success: false,
			inserted: [],
			//inProgess: false,
			aquaTetels: ['9','12','53','38','30','29','37','56'],
			penztar: [],
			selectedPenztar: -1,
			kiszallitok: [],
			selectedKiszallito: -1
		}
	},

	mounted(){
		this.$Progress.start()
		this.datum = this.renddatum
		this.szla_szolg = this.rend_sel_customer.szolgaltato !== 0 ? this.rend_sel_customer.szolgaltato : 1
		this.szla_tipus = this.rend_sel_customer.szla_tipus !== 0 ? this.rend_sel_customer.szla_tipus : 1
		this.regio = this.rend_sel_customer.regio || 0
      	this.req.post('/others', {
      		datum: this.renddatum
      	})
          	.then(res => {
          		this.penztar = res.data.penztar
              	this.szolg = res.data.szolg
              	this.kiszallitok = res.data.kiszallitok
              	this.$Progress.finish()
          	})
          	.then(res2 => {
          		this.setKiszallito()
          	})
          	.catch(err => {
              	this.$Progress.fail()
          	})
	},
	
	methods: {
		...mapActions(['clearCart','setrenddatum']),

		setKiszallito() {
			let r = this.regio
			for (let val of this.kiszallitok2) {
				if(r >= ~~val.regio && r <= ~~val.regio_max) {
					this.selectedKiszallito = val.azon
					break
				}
			}
		},
		
		insertedOrder(){
			this.$Progress.start()
			this.req.post('/orders/insertedOrder', {
				rendszam: this.rendszam
			})
				.then(res => {
					this.$Progress.finish()
					this.inserted = res.data.list
				})
				.catch(err => {
					console.log(err)
					this.$Progress.fail()
					toastr.error(err.response.data.text || 'Lekérdezés sikertelen')
				})
		},

		refreshdate(){
			this.setrenddatum(this.$moment(this.datum).format('YYYY-MM-DD'))
		},

		preorder(){
			if (confirm('Biztos mai napi kiszállítással akarod rögzíteni a rendelést??')) {
			    this.save()
			}
		},

		order(){
			this.save()
		},

		save(){
			//this.inProgess = true
			this.$Progress.start()
			this.req.post('/orders/saveorder',{
				orders: this.orderdetails,
				email_details: this.email_details,
				dateconfirm: this.isActDay
			})
				.then(res => {
					this.$Progress.finish()
					toastr.success('Rögzítés sikeres')
					this.success = true
					this.insertedOrder()
				})
				.catch(err => {
					//this.inProgess = false
					console.log(err)
					this.$Progress.fail()
					toastr.error(err.response.data.text || 'Rögzítés sikertelen')
				})
		},

		reset(){
			this.clearCart()
			this.$router.push({ path: `/orders/new_order/customer` })
		}
	},

	computed: {
		...mapGetters(['rend_sel_customer','inCart','rendszam','user','renddatum','cartSum']),

		orderdetails(){
			var arr = []
			this.inCart.map(x=>{
				arr.push({
					user: this.user.nev,
					user_id: 0,
					prio: 0,
					datum: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
					kidatum: this.$moment(this.datum).format('YYYY-MM-DD'),
					zardatum: this.lezarva?this.$moment().format('YYYY-MM-DD'):`2000-01-01`,
					uszam: this.rend_sel_customer.id,
					rendelesszam: this.rendszam,
					regio: this.regio,
					tszam: x.tszam,
					db: x.db,
					ar: x.ar,
					rendmegj: x.rendmegj,
					szalmegj: ``,
					aktiv: this.lezarva?0:this.aktiv,
					lezarta0: ``,
					lezarta1: ``,
					lezarta2: 0,
					szamlazva: this.szamlazva?1:0,
					check: 0,
					szla_tipus: this.szla_tipus,
					szla_szolg: this.aquaTetels.includes(x.tszam) ? 1 : this.szla_szolg,
					fizetve: this.selectedPenztar != -1 ? 1 : 0,
					fizetve_datum: this.selectedPenztar != -1 ? this.$moment().format('YYYY-MM-DD') : null,
					fizetve_hely: this.selectedPenztar != -1 ? this.selectedPenztar : null,
					kiszallito: this.selectedKiszallito != -1 ? this.selectedKiszallito : null
				})
			})
			return arr
		},

		email_details(){
			var obj = {}
			obj.user = this.user.nev
			obj.datum = this.$moment().format('YYYY-MM-DD HH:mm:ss')
			obj.vevo = this.rend_sel_customer.nev
			obj.rszam = this.rendszam
			obj.regio = this.regio
			obj.varos = this.rend_sel_customer.szalvaros
			obj.cim = this.rend_sel_customer.szal_cim_utca !== `` && this.rend_sel_customer.szal_cim_utca !== null ? this.rend_sel_customer.szal_cim_utca + ' ' + this.rend_sel_customer.szal_cim_hsz + ' ' + this.rend_sel_customer.szal_cim_ea : this.rend_sel_customer.szalcim
			var arr = []
			this.inCart.map(x=>{
				arr.push({
					termek: x.nev,
					db: x.db,
					egysegar: x.ar,
					ar: x.db * x.ar,
					megj: x.rendmegj
				})
			})
			obj.orders = arr
			return obj
		},

		isActDay(){
			return this.datum === this.$moment(new Date()).format('YYYY-MM-DD')
		},

		kiszallitok2() {
			let r = this.regio
			let arr = this.kiszallitok.filter(x => r >= x.regio && r <= x.regio_max)
			return arr
		}
	},

	watch: {
		datum() {
			this.req.post('/others', {
				datum: this.renddatum
			})
	          	.then(res => {
	              	this.kiszallitok = res.data.kiszallitok
	              	this.$Progress.finish()
	          	})
	          	
	          	.catch(err => {
	              	this.$Progress.fail()
	          	})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/orders/new_order/order_sum.vue